

























import Vue from "vue";
import { mapState, mapGetters } from "vuex";
import PriorityList from "../components/billing/priority-list.vue";

export default Vue.extend({
  components: { PriorityList },
  data() {
    return {
      selectedMemberId: null,
      userId: 1,
      name: "Test",
      email: "test@gmail.com",
      phone: 111 - 111 - 1111,
    };
  },
  computed: {
    ...mapState("session", ["user"]),
    ...mapState("billing", ["loading", "billingAccount"]),
    ...mapGetters("billing", ["hasUserManagementPermission"]),
    currentUser() {
      let context = this as any;
      if (context.billingAccount && context.billingAccount.members && context.selectedMemberId) {
        let users = context.billingAccount.members.filter((m) => m.memberId.toString() === context.selectedMemberId.toString());
        if (users.length === 1) {
          return users[0];
        }
      }

      return null;
    },
    selectedMemberTitle() {
      let context = this as any;
      let currentUser = context.currentUser;
      return currentUser ? context.getUserTitle(currentUser) : "";
    },
    hashTags() {
      let hashTags = ["All"];
      return [...new Set(hashTags)];
    },
    members() {
      let context = this as any;
      return context.billingAccount ? context.billingAccount.members : [];
    },
  },
  watch: {
    user(newValue) {
      if (newValue) {
        this.selectedMemberId = newValue.id;

        (this as any).$intercom.boot({
          user_id: (this as any).user.id,
          user_hash: (this as any).user.intercomUserHash,
          name: (this as any).user.name,
          email: (this as any).user.emailAddress,
          phone: (this as any).user.phoneNumber,
        });
        (this as any).$intercom.show();
      }
    },
    selectedMemberId(newValue) {
      if (newValue) {
        this.loadJoinedGroups();
      }
    },
    email(email) {
      (this as any).$intercom.update({ email });
    },
  },
  created() {
    //this.$store.dispatch("goal/getMyGoals", {});
  },
  mounted() {
    if ((this as any).user) {
      this.selectedMemberId = (this as any).user.id;
    }
  },
  methods: {
    loadJoinedGroups() {
      let context = this as any;
      this.$store
        .dispatch("billing/getJoinedGroups", { data: { memberId: context.selectedMemberId } })
        .then((response) => {})
        .finally(() => {});
    },
    getUserTitle(user) {
      let roleName = "User";
      switch (user.role) {
        case 1:
          roleName = "Admin";
          break;
        case 2:
          roleName = "Manager";
          break;
        case 3:
          roleName = "User";
          break;
        default:
          roleName = "User";
          break;
      }

      return `${user.memberName} - ${roleName}`;
    },
  },
});
